import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
interface PrivacyPageProps {
  onNavigate?: (path: string) => void;
}
export function PrivacyPage({
  onNavigate
}: PrivacyPageProps) {
  return <div className="min-h-screen bg-[#f5f5f7] text-[#1f2933]" data-id="element-1688">
      <Navbar onNavigate={onNavigate} data-id="element-1689" />

      <section className="py-24" data-id="element-1690">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-1691">
          <h1 className="text-4xl font-bold mb-8" data-id="element-1692">Privacy Policy</h1>
          <p className="text-sm text-[#9ca3af] font-mono mb-12" data-id="element-1693">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <div className="space-y-8 bg-white border-2 border-dashed border-[#9ca3af] p-8" data-id="element-1694">
            <section data-id="element-1695">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1696">
                1. Information We Collect
              </h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1697">
                We collect information that you provide directly to us,
                including:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1698">
                <li data-id="element-1699">Name and contact information (email, phone number)</li>
                <li data-id="element-1700">Payment information (processed securely through Selar)</li>
                <li data-id="element-1701">Profile information for accountability pods</li>
                <li data-id="element-1702">Content and communications within the program</li>
              </ul>
            </section>

            <section data-id="element-1703">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1704">
                2. How We Use Your Information
              </h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1705">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1706">
                <li data-id="element-1707">Provide and improve The Authority Engine program</li>
                <li data-id="element-1708">Process payments and manage your account</li>
                <li data-id="element-1709">Match you with appropriate accountability pods</li>
                <li data-id="element-1710">Send program updates and educational content</li>
                <li data-id="element-1711">Respond to your questions and support requests</li>
              </ul>
            </section>

            <section data-id="element-1712">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1713">
                3. Information Sharing
              </h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1714">
                We do not sell your personal information. We may share your
                information:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1715">
                <li data-id="element-1716">
                  With your accountability pod members (name and relevant
                  profile information)
                </li>
                <li data-id="element-1717">
                  With service providers who assist in program delivery (e.g.,
                  payment processors)
                </li>
                <li data-id="element-1718">When required by law or to protect our rights</li>
              </ul>
            </section>

            <section data-id="element-1719">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1720">4. Data Security</h2>
              <p className="text-[#1f2933]/80" data-id="element-1721">
                We implement appropriate technical and organizational measures
                to protect your personal information. However, no method of
                transmission over the internet is 100% secure, and we cannot
                guarantee absolute security.
              </p>
            </section>

            <section data-id="element-1722">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1723">5. Your Rights</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1724">You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1725">
                <li data-id="element-1726">Access your personal information</li>
                <li data-id="element-1727">Correct inaccurate information</li>
                <li data-id="element-1728">
                  Request deletion of your information (subject to legal
                  obligations)
                </li>
                <li data-id="element-1729">Opt-out of marketing communications</li>
              </ul>
            </section>

            <section data-id="element-1730">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1731">
                6. Cookies and Tracking
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1732">
                We use cookies and similar tracking technologies to improve your
                experience and analyze program usage. You can control cookies
                through your browser settings.
              </p>
            </section>

            <section data-id="element-1733">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1734">
                7. Third-Party Services
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1735">
                We use third-party services including Selar (payments), WhatsApp
                (community), and Formspree (forms). These services have their
                own privacy policies governing the use of your information.
              </p>
            </section>

            <section data-id="element-1736">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1737">
                8. Changes to This Policy
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1738">
                We may update this Privacy Policy from time to time. We will
                notify you of significant changes by posting the new policy on
                this page and updating the "Last updated" date.
              </p>
            </section>

            <section data-id="element-1739">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1740">9. Contact Us</h2>
              <p className="text-[#1f2933]/80" data-id="element-1741">
                If you have questions about this Privacy Policy or our data
                practices, please contact us through our community WhatsApp
                group or email support.
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer onNavigate={onNavigate} data-id="element-1742" />
    </div>;
}